
  Vue.component('user-invites-resend-popup', {
    props: {
      widgetList: { type: Array, required: true }
    },
    data() {
      return {
        visible: true,
        formInterfaces: {},
        selectedWidgetId: `${this.widgetList[0].id}`
      }
    },
    template: '#user-invites-resend-popup',
    computed: {
      formFields() {
        return [
          {
            id: 0,
            fieldName: 'WidgetId',
            label: 'Seleziona un widget tra quelli disponibili',
            inputType: 'radio',
            value: this.selectedWidgetId,
            options: this.widgetList.map(wid => ({ ...wid, valueIfChecked: `${wid.id}` })),
            validators: [{ type: 'required' }]
          }
        ]
      }
    },
    watch: {},
    methods: {
      handleChange(param) {
        if (param.fieldName === 'WidgetId') {
          this.selectedWidgetId = param.value
          EventBus.selectedWidgetId = param.value
        }
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      }
    },
    mounted() {
      EventBus.selectedWidgetId = this.selectedWidgetId
    },
    beforeDestroy() {}
  })
